module.exports = __webpack_public_path__ + "img/noResult3.1cd889aa.png";